var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStatusSuspend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.117 22.341h-8.43V2.107H8.43v5.059a1.691 1.691 0 001.686 1.686h5.058v2.53h1.686V7.165a.768.768 0 00-.252-.59L10.707.674a.768.768 0 00-.59-.253h-8.43A1.691 1.691 0 000 2.107v20.234a1.691 1.691 0 001.686 1.686h8.43v-1.686zm0-19.896l4.721 4.72h-4.721v-4.72z",
    fill: "#ED1B2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.989 18.426a1.499 1.499 0 00-1.5 1.498v2.998a1.499 1.499 0 002.998 0v-2.998a1.5 1.5 0 00-1.498-1.498zm.57-4.377a1.5 1.5 0 00-.87-.12l-.27.09-.27.135-.225.18a1.498 1.498 0 00-.434 1.094 1.5 1.5 0 00.434 1.064c.143.137.311.244.495.315.178.084.373.125.57.12a1.5 1.5 0 001.064-.435 1.5 1.5 0 00.434-1.064 1.498 1.498 0 00-.434-1.064 1.724 1.724 0 00-.495-.315z",
    fill: "#ED1B2E"
  })));
}

export default SvgStatusSuspend;